import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MijnAuthSessieManagerService, MijnJwtService } from '@ap/mijn-auth-sessie-manager';
import { ApContentService } from '@ap/content';

import content from '../mijn-omgeving.content.json';

/**
 * @ngdoc component
 * @name Auth0sessionComponent
 * @module Auth0sessionModule
 */
@Component({
    selector: 'auth0session',
    templateUrl: './auth0session.component.html',
    standalone: false
})
export class Auth0sessionComponent implements OnInit {
    public claimExp: string;
    public authenticated = false;
    public constructor(
        public readonly auth: MijnAuthSessieManagerService,
        private readonly jwtService: MijnJwtService,
        private readonly contentService: ApContentService
    ) {}

    ngOnInit() {
        this.contentService.addContentItems(content);
        this.auth0isAuthenticated().subscribe((result) => {
            this.authenticated = result;
            if (this.authenticated) {
                this.getTokenData();
                setInterval(() => this.getTokenData(), 1000 * 10); // Check every 10 sec
            }
        });
    }

    public auth0isAuthenticated(): Observable<boolean> {
        return this.auth.isAuthenticated$.pipe(catchError(() => of(false)));
    }

    public auth0logout() {
        this.auth.logout().subscribe();
    }

    private getTokenData() {
        this.authenticated = this.jwtService.isAuthenticated();
        const token = this.jwtService.getToken();
        if (token) {
            const { exp } = JSON.parse(atob(token.split('.')[1]));
            const milliSeconds = exp * 1000 - Date.now();
            this.claimExp = milliSeconds > 0 ? this.convertMsToTimestamp(milliSeconds) : 'expired';
        }
    }

    private convertMsToTimestamp(milliseconds: number): string {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return [hours, minutes, seconds].map((val) => val.toString().padStart(2, '0')).join(':');
    }
}
